/**
 * Where another application is entered. The organization goes along so the application's first
 * token is for the same organization as this one.
 */
export const getAppEntryUrl = (appUrl: string, organizationId?: string): string => {
	if (!organizationId) {
		return appUrl
	}

	const [path, query] = appUrl.split('?')
	const queryParams = new URLSearchParams(query)
	queryParams.set('organizationId', organizationId)
	return `${path}?${queryParams.toString()}`
}
